import { render } from "./OrderTatalPoints.vue?vue&type=template&id=0412dfb2&scoped=true"
import script from "./OrderTatalPoints.vue?vue&type=script&lang=js"
export * from "./OrderTatalPoints.vue?vue&type=script&lang=js"

import "./OrderTatalPoints.vue?vue&type=style&index=0&id=0412dfb2&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0412dfb2"]])

export default __exports__